import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates, TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { useApplicationContext } from '../../../../../utils/applicationContext';
import { NewbuildingSpecialProject } from '../templates/NewbuildingSpecialProject';
import { NewbuildingSpecialProjectAnimated } from '../templates/NewbuildingSpecialProjectAnimated';
import { TgbNativedescGeneralContainer } from '../templates/TgbNativedescGeneral';

import type {
  INewbuildingSpecialProjectBannerAnimateContext,
  INewbuildingSpecialProjectBannerContext,
} from '../../../../../types/adfox';

const OWN_BUNDLE_NAMES = ['banner.transfer'];
const OWN_TYPES: Array<BannerContext['type']> = [
  'special_project_banner',
  'special_project_banner_animate',
  'tgb_nativedesc_general',
];

type BannerContext =
  | INewbuildingSpecialProjectBannerContext
  | INewbuildingSpecialProjectBannerAnimateContext
  | TTgbNativedescGeneralContext;

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  const ctx = useApplicationContext();
  const { bundleName, bundleParams, minHeight, minWidth, maxHeight, maxWidth, width, height } = props;

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          if (OWN_TYPES.includes(parsedDecodedParams.type)) {
            switch (parsedDecodedParams.type) {
              case 'special_project_banner':
                return (
                  <NewbuildingSpecialProject
                    context={parsedDecodedParams}
                    sizes={{ minHeight, minWidth, maxHeight, maxWidth, width, height }}
                  />
                );
              case 'special_project_banner_animate':
                return (
                  <NewbuildingSpecialProjectAnimated
                    context={parsedDecodedParams}
                    sizes={{ minHeight, minWidth, maxHeight, maxWidth, width, height }}
                  />
                );

              case 'tgb_nativedesc_general':
                return <TgbNativedescGeneralContainer context={parsedDecodedParams} />;
            }
          }
        }
      } catch (e) {
        ctx.logger.error(e, {
          message: '[AdFox] Failed to decode/parse bundleParams',
          bannerId: props.bundleParams?.bannerId,
        });
      }
    }
  }

  return <AdFoxTemplates deviceType="desktop" {...props} />;
};

function isParsedParamsValid(params: object): params is BannerContext {
  return 'type' in params;
}
